import React from 'react';
import { useSelector } from 'react-redux';

import {
  PlanState,
  GET_PLAN_LIST_ID,
  PlanInitialState
} from 'common/modules/domain/plan';
import { UserInformation } from 'common/modules/domain/user';
import { FetchState, FetchStatus } from 'common/modules/app/fetch';
import { ErrorState } from 'common/modules/app/errors';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { AppState } from 'pages';
import {
  PlanListMessage,
  MESSAGE_TYPES_KEY
} from 'pages/plan-list/components/PlanListMessage';

/** Stateからエラーメッセージ用のPropsに変換する */
const _convertMessageProps = (
  user: UserInformation,
  fetchState: FetchState,
  errorState: ErrorState,
  planState: PlanState
): { show: boolean; messageType?: MESSAGE_TYPES_KEY } => {
  if (!user.country) {
    return { show: true, messageType: 'notSelectedCountry' };
  }
  if (
    fetchState[GET_PLAN_LIST_ID] !== FetchStatus.UNTREATED &&
    fetchState[GET_PLAN_LIST_ID] !== FetchStatus.FAILED
  ) {
    return { show: false };
  }
  if (errorState.requestId === GET_PLAN_LIST_ID) {
    return { show: true, messageType: 'otherError' };
  }
  if (!Object.keys(planState).length) {
    return { show: true, messageType: 'notFoundAnyPlan' };
  }
  return { show: false };
};

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const planState = useSelector<AppState, PlanInitialState>(
    (state) => state.domain.plan
  );
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );
  const errorState = useSelector<AppState, ErrorState>(
    (state) => state.app.error
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );

  return {
    ..._convertMessageProps(
      userState,
      fetchState,
      errorState,
      planState.planList
    ),
    glossary: Glossary.instance(glState)
  };
};

/**
 * プランリストに表示するエラーメッセージのContainer Component
 */
export default function ContainerComponent() {
  const _props = useStateProps();
  return <PlanListMessage {..._props} />;
}
